module.exports = __webpack_public_path__ + "static/marthammor-symbol-DND3_FnP-fa0e71776e5b82a8dc6ce02d04fbd9bc.webp";